import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, Result, Layout } from 'antd';
import { CheckCircleOutlined, PlusOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import AppHeader from '../components/Header';
import authService from '../services/authService';

const { Content } = Layout;

const ThankYou = () => {
  const navigate = useNavigate();
  const { companyId, formId } = useParams();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Handle responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSubmitNewLead = () => {
    navigate(`/companies/${companyId}/site_visit_forms/${formId}/view`);
  };

  const handleBackToForms = () => {
    navigate(`/companies/${companyId}/site_visit_forms/list`);
  };

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
    setDrawerVisible(false);
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Profile',
      onClick: () => navigate('/')
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: handleLogout,
      danger: true
    }
  ];

  const formMeta = {
    name: 'Thank You'
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AppHeader 
        isMobile={isMobile}
        formMeta={formMeta}
        userMenuItems={userMenuItems}
        drawerVisible={drawerVisible}
        setDrawerVisible={setDrawerVisible}
        handleLogout={handleLogout}
      />
      
      <Content style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: '#f0f2f5',
        padding: isMobile ? 12 : 24
      }}>
        <Card style={{ maxWidth: 600, width: '100%', textAlign: 'center' }}>
          <Result
            icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
            status="success"
            title="Form Submitted Successfully!"
            subTitle="Thank you for submitting the site visit form. Your information has been recorded."
            extra={[
              <Button 
                type="primary" 
                size="large"
                icon={<PlusOutlined />}
                onClick={handleSubmitNewLead}
                style={{ background: '#5568d3', marginRight: 8 }}
                key="submit-new"
              >
                Submit New Lead
              </Button>,
              <Button 
                size="large"
                onClick={handleBackToForms}
                key="back"
              >
                Back to Forms
              </Button>
            ]}
          />
        </Card>
      </Content>
    </Layout>
  );
};

export default ThankYou;
